import * as reducers from './reducers';

export default { reducers };
